import { eAccessControlUserType } from '../../../enums/eAccessControlUserType';
import { clientUrls } from '../../../rest/ClientUrlFactory';

export const createDefaultGlobalNavigation = (userType: eAccessControlUserType, isAdministration: boolean = false) => {
  switch (userType) {
    case eAccessControlUserType.Admin:
      return [
        { to: clientUrls.urlFor.adminOrders(), text: 'Orders' },
        { to: clientUrls.urlFor.escrowIndex(), text: 'Accounting' },
        { to: clientUrls.urlFor.lendersIndex(), text: 'Lenders' },
        { to: clientUrls.urlFor.clientCompaniesIndex(), text: 'Clients' },
        ...(isAdministration ? [{ to: clientUrls.urlFor.administrationIndex(), text: 'Administration' }] : []),
      ];
    case eAccessControlUserType.Client:
      return [
        { to: clientUrls.urlFor.clientOrders(), text: 'Orders' },
      ];
    default:
      return [];
  }
};

export const DefaultHomeLink = (userType: eAccessControlUserType): string => {
  const homeLinks: Record<eAccessControlUserType, string> = {
    [eAccessControlUserType.Admin]: clientUrls.urlFor.dashboard(),
    [eAccessControlUserType.Client]: clientUrls.urlFor.clientOrders(),
    [eAccessControlUserType.Vendor]: clientUrls.urlFor.vendorOrders(),
    [eAccessControlUserType.None]: '',
  };
  return homeLinks[userType];
};
